// extracted by mini-css-extract-plugin
module.exports = {"Banner":"Banner_Banner__3XHDX","Background":"Banner_Background__YO01Y","Content":"Banner_Content__AS_Ix"};